import React, { Component } from 'react';

export default class SelectedOptions extends Component {
    render() {
        const options = this.props.options;

        return (
            <div className="selectedOptions">
                <ul>
                    {options
                        .map((optionValue, index) => (
                            <div key={index}>
                                {optionValue.code ? optionValue.code + " : " : ""}{optionValue.description}
                                {optionValue.currentValue ? " | " + optionValue.currentValue : ""}
                            </div>
                        ))}
                </ul>
            </div>
        );
    }
}